
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "h-7 w-7",
    md: "h-9 w-9",
    lg: "h-12 w-12",
  };

  const textClasses = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-2xl",
  };

  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`}>
      {/* Clean gradient icon */}
      <div className={`${sizeClasses[size]} rounded-xl bg-primary flex items-center justify-center shadow-sm`}>
        <svg viewBox="0 0 24 24" className="w-5 h-5 text-primary-foreground" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="2" width="16" height="20" rx="2" />
          <line x1="8" y1="6" x2="16" y2="6" />
          <line x1="8" y1="10" x2="10" y2="10" />
          <line x1="12" y1="10" x2="14" y2="10" />
          <line x1="8" y1="14" x2="10" y2="14" />
          <line x1="12" y1="14" x2="14" y2="14" />
          <line x1="8" y1="18" x2="14" y2="18" />
        </svg>
      </div>
      <span className={`font-bold tracking-tight ${textClasses[size]} text-foreground`}>
        Get<span className="text-primary">Calculator</span>
      </span>
    </Link>
  );
};

export default Logo;
